// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"8f6d180d","107":"d81e056b","349":"6d5608f0"}[chunkId] + ".chunk.css";
};